import script from "./Watermarks.vue?vue&type=script&setup=true&lang=ts"
export * from "./Watermarks.vue?vue&type=script&setup=true&lang=ts"

import "./Watermarks.scss?vue&type=style&index=0&id=62e5e39e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e5e39e"]])

export default __exports__